import { cn } from '@/lib/utils';
import type { ExtractionFieldData } from './ExtractionField';

export type FieldStatus = 'confirmed' | 'inferred' | 'low_confidence' | 'missing';

export function deriveFieldStatus(field: ExtractionFieldData): FieldStatus {
  const { detection_status, confirmation_status, confidence } = field;
  if (confirmation_status === 'confirmed' || confirmation_status === 'edited') return 'confirmed';
  if (detection_status === 'missing') return 'missing';
  if (confirmation_status === 'accepted') return 'confirmed';
  if (confidence >= 0.6) return 'inferred';
  return 'low_confidence';
}

/** @deprecated Use deriveFieldStatus */
export function getFieldStatus(confidence: number, rawStatus: string): FieldStatus {
  if (rawStatus === 'confirmed') return 'confirmed';
  if (rawStatus === 'missing' || confidence < 0.3) return 'missing';
  if (confidence < 0.6) return 'low_confidence';
  return 'inferred';
}

interface ConfidenceBadgeProps {
  field: ExtractionFieldData;
  className?: string;
}

export const ConfidenceBadge = ({ field, className }: ConfidenceBadgeProps) => {
  const status = deriveFieldStatus(field);

  const configs: Record<FieldStatus, { label: string; dot: string; text: string }> = {
    confirmed: {
      label: 'bestätigt',
      dot: 'bg-emerald-500',
      text: 'text-emerald-700 dark:text-emerald-400',
    },
    inferred: {
      label: 'hoch sicher',
      dot: 'bg-primary',
      text: 'text-primary',
    },
    low_confidence: {
      label: 'prüfen',
      dot: 'bg-amber-500',
      text: 'text-amber-700 dark:text-amber-400',
    },
    missing: {
      label: 'fehlt',
      dot: 'bg-destructive',
      text: 'text-destructive',
    },
  };

  const config = configs[status];

  return (
    <span className={cn(
      'inline-flex items-center gap-1.5 text-[10px] font-medium tracking-wide',
      config.text,
      className
    )}>
      <span className={cn('w-1.5 h-1.5 rounded-full', config.dot)} />
      {config.label}
    </span>
  );
};
